import React from 'react';
import './GoTop.css';

const GoTop = (props) => {

    const [thePosition, setThePosition] = React.useState(false);
    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 170) {
                setThePosition(true)
            } else {
                setThePosition(false);
            }
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => window.removeEventListener("scroll", handleScroll);
    }, [])

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const renderGoTopIcon = () => {
        if(thePosition){
            return (
                <button className="go-top" type="button" onClick={scrollToTop} aria-label="Back to top">
                    <i className="fas fa-arrow-up"></i>
                    <i className="fas fa-arrow-up"></i>
                </button>
            )
        }
    }

    return (
        <>
            {renderGoTopIcon()}
        </>
    )
}

export default GoTop;
